import { useState } from 'react';
import { Container, Button, Title, Text, Anchor, Divider, Loader } from '@mantine/core';
import {Space} from "lucide-react";

const MachineLearningDasar = () => {
    return (
        <div className="min-h-screen bg-gray-50 p-4 mt-6">
            <div className="max-w-full sm:max-w-6xl mx-auto bg-white rounded-2xl shadow-md overflow-hidden p-6">
                <div className="flex flex-col items-center">
                    <img
                        src="https://dinus.ac.id/wp-content/uploads/2023/11/LogoUdinus.png"
                        className="w-14 mb-2"
                        alt="Logo"
                    />
                    <p className="text-sm text-gray-600 mt-1">P31.2024.02640 - Ahmad Mursyidi</p>
                    <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800 text-center mt-0">
                        Tugas Implementasi Machine Learning
                    </h1>
                </div>

                <Container >
                    <Text align="center" size="sm" sm="md" mt={8}>
                        Mengimplementasikan  teknik  <strong>Machine Learning</strong> menggunakan Matlab.
                    </Text>
                    <Divider my="sm" />

                    <Text size="sm" sm="md" style={{ textAlign: 'justify' }}>
                        <strong>Implementasi Metode Machine Learning:</strong>
                        <br/>
                        <p>
                            Dalam Uji coba ini, saya mengimplementasikan model <strong>Random Forest</strong> dan <strong>Decision Tree</strong> pada sebuah dataset yang berfokus pada kondisi kesehatan mental dan gaya hidup individu. Dataset tersebut mencakup berbagai fitur, seperti <strong>Usia, Tingkat Aktivitas Fisik, Jam Tidur, dan Tipe Diet</strong>.
                        </p>
                        <br/>
                        <p>
                            Sebelum digunakan dalam pemodelan, dataset ini telah diproses dengan mengonversi kolom-kolom kategorikal menjadi format numerik untuk mempermudah analisis. Setelah tahap pemrosesan, data dibagi menjadi dua bagian: 70% untuk data pelatihan dan 30% untuk data pengujian.
                        </p>
                        <br/>
                        <p>
                            Model-model machine learning yang diterapkan dalam percobaan ini meliputi <strong>Decision Tree</strong> dan <strong>Random Forest</strong>, yang masing-masing diimplementasikan dengan dan tanpa proses tuning parameter.
                        </p>
                        <br/>
                        <p>
                            Berdasarkan hasil evaluasi, model ini menunjukkan akurasi yang berkisar antara 18% hingga 20%, dengan penyesuaian parameter yang memberikan sedikit peningkatan pada performa model <strong>Random Forest</strong>.
                        </p>
                    </Text>



                    <Divider my="sm" />

                    <Text size="sm" sm="md">
                        <strong>Link Tugas:</strong>
                        <ul>
                            <li>
                                <Anchor href="https://www.kaggle.com/datasets/atharvasoundankar/mental-health-and-lifestyle-habits-2019-2024/data" target="_blank">Link Dataset di Kaggle</Anchor>
                            </li>
                            <li>
                                <Anchor href="https://be-mti-udinus.aemde.uk/download/zip/implementasi-machine-learning2.zip" target="_blank">Link ke file Matlab</Anchor>
                            </li>
                        </ul>
                    </Text>

                    <Button
                        variant="outline"
                        color="blue"
                        size="lg"
                        mt={30}
                        fullWidth
                        component="a"
                        href="https://be-mti-udinus.aemde.uk/download/zip/implementasi-machine-learning2.zip"
                        target="_blank"
                    >
                        Unduh File Tugas
                    </Button>
                </Container>
            </div>
        </div>
    );
}

export default MachineLearningDasar;
